module.exports = __webpack_public_path__ + "static/earth-14cf3ccd0345abfcc750863249448d3f.svg";